import type { PageInfoHookProps } from '~/hooks/usePageInfo'

interface TrackPageInfoProps extends PageInfoHookProps {
  eventName?: string
  loggedIn?: boolean
}

type PageInfoObject = {
  page_type: string
  page_name?: string
  category_type?: string
  category_level_one?: string
  category_level_two?: string
  logged_in?: string
}

export const trackPageInfo = ({
  eventName = 'page_information',
  pageType,
  pageTitle,
  categoryType,
  categoryTitle,
  categoryParentTitle,
  loggedIn,
}: TrackPageInfoProps) => {
  if (!pageType) return

  const pageInfo: PageInfoObject = {
    page_type: pageType,
  }

  if (pageTitle) {
    pageInfo.page_name = pageTitle
  }

  if (categoryType) {
    pageInfo.category_type = categoryType
  }

  if (categoryParentTitle) {
    pageInfo.category_level_one = categoryParentTitle
  }

  if (categoryTitle) {
    if (!categoryParentTitle) {
      pageInfo.category_level_one = categoryTitle
    } else {
      pageInfo.category_level_two = categoryTitle
    }
  }

  pageInfo.logged_in = loggedIn ? 'yes' : 'no'

  if (typeof window !== 'undefined') {
    window?.dataLayer?.push({
      event: eventName,
      page_info: pageInfo,
    })
  }
}

export const isGtmLoaded = () => {
  if (typeof window == 'undefined') return false

  window.dataLayer = window.dataLayer || []

  const gtmStartedEvent = window.dataLayer.find((e: any) => e['gtm.start'])

  if (!gtmStartedEvent) {
    return false // Not even the GTM inline config has executed
  }

  return true // GTM is fully loaded and working
}
